"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Application_1 = __importDefault(require("./Application"));
const Contact_1 = __importDefault(require("./Contact"));
const Hook_1 = __importDefault(require("./Hook"));
const Authorization_1 = __importDefault(require("./Authorization"));
const Comment_1 = __importDefault(require("./Comment"));
const Files_1 = __importDefault(require("./Files"));
const Item_1 = __importDefault(require("./Item"));
const Status_1 = __importDefault(require("./Status"));
const Task_1 = __importDefault(require("./Task"));
const Request_1 = __importDefault(require("./Request"));
const Space_1 = __importDefault(require("./Space"));
const User_1 = __importDefault(require("./User"));
const Organization_1 = __importDefault(require("./Organization"));
const Action_1 = __importDefault(require("./Action"));
const AppMarket_1 = __importDefault(require("./AppMarket"));
const Batch_1 = __importDefault(require("./Batch"));
const Calendar_1 = __importDefault(require("./Calendar"));
const Conversation_1 = __importDefault(require("./Conversation"));
const Device_1 = __importDefault(require("./Device"));
const Email_1 = __importDefault(require("./Email"));
const Embed_1 = __importDefault(require("./Embed"));
const Flow_1 = __importDefault(require("./Flow"));
const Form_1 = __importDefault(require("./Form"));
const Friend_1 = __importDefault(require("./Friend"));
const Grant_1 = __importDefault(require("./Grant"));
const Importer_1 = __importDefault(require("./Importer"));
exports.default = {
    request: (props) => new Request_1.default(props),
    authorization: (props) => new Authorization_1.default(props),
    action: (props) => new Action_1.default(props),
    appMaket: (props) => new AppMarket_1.default(props),
    app: (props) => new Application_1.default(props),
    batch: (props) => new Batch_1.default(props),
    calendar: (props) => new Calendar_1.default(props),
    comment: (props) => new Comment_1.default(props),
    contact: (props) => new Contact_1.default(props),
    conversation: (props) => new Conversation_1.default(props),
    device: (props) => new Device_1.default(props),
    email: (props) => new Email_1.default(props),
    item: (props) => new Item_1.default(props),
    embed: (props) => new Embed_1.default(props),
    files: (props) => new Files_1.default(props),
    flow: (props) => new Flow_1.default(props),
    form: (props) => new Form_1.default(props),
    friend: (props) => new Friend_1.default(props),
    grant: (props) => new Grant_1.default(props),
    hook: (props) => new Hook_1.default(props),
    importer: (props) => new Importer_1.default(props),
    task: (props) => new Task_1.default(props),
    status: (props) => new Status_1.default(props),
    space: (props) => new Space_1.default(props),
    user: (props) => new User_1.default(props),
    organization: (props) => new Organization_1.default(props),
};
